import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Forward } from "@material-ui/icons";

export const AssignerButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Button = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;

  width: 3rem;

  svg {
    font-size: 2rem;
  }
`;

export const AssignIcon = styled(Forward)`
  color: ${({ theme }) => theme.colors.secondaryColor};
`;

export const UnassignIcon = styled(Forward)`
  color: ${({ theme }) => theme.colors.secondaryColor};
  transform: rotate(180deg);
`;
